<template>
  <v-dialog max-width="800px" v-model="dialogModel">
    <v-card>
      <v-card-title>
        <v-layout align-center fill-height justify-space-between row>
          <v-flex>
            <span v-if="product">
              <Address></Address>
              <h4>{{ this.product.name }}</h4>
            </span>
          </v-flex>
          <v-flex xs3>
            <input
              @change="addNewImage($event.target.files[0])"
              name="newImage"
              ref="imageInput"
              v-show="false"
              type="file"
            />
            <v-btn
              v-show="!imagesProduct.length"
              @click="$refs.imageInput.click()"
              color="primary"
              dark
              medium
            >
              <i class="material-icons">add</i>
              {{$t('message.newImage')}}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-layout align-center justify-center row wrap>
          <template v-if="loadingImages">
            <v-text-field color="success" disabled loading></v-text-field>
          </template>
          <template v-else>
            <div :key="image.id" class="image-preview elevation-2" v-for="image of imagesProduct">
              <v-btn @click="deleteImage(image)" class="delete-button" color="error" dark fab small>
                <v-icon dark>delete</v-icon>
              </v-btn>
              <img :src="image.full_url_image" />
            </div>
            <div :key="index" class="image-preview" v-for="(newImage, index) of newImages">
              <v-btn
                @click="deleteNewImage(index)"
                class="delete-button"
                color="error"
                dark
                fab
                small
              >
                <v-icon dark>delete</v-icon>
              </v-btn>
              <img :src="newImage.imageUrl" />
            </div>
          </template>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outline @click="onClose" color="error" small>{{ $t('message.close') }}</v-btn>
        <v-btn outline @click="onSave" color="primary" small>{{ $t('message.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import {
  ADD_IMAGE_PRODUCT,
  DELETE_IMAGE_PRODUCT,
  GET_IMAGES_PRODUCT
} from "../../store/modules/products/actions.type";

export default {
  name: "imageManage",
  props: {
    dialog: {
      required: false,
      default: false
    },
    isEdit: {
      required: false,
      default: false
    }
  },
  data() {
    return {
      product: null,
      images: [],
      newImages: [],
      dialogModel: this.dialog
    };
  },
  computed: {
    ...mapGetters({
      imagesProduct: "imagesProduct",
      loadingImages: "loadingImages"
    })
  },
  methods: {
    addNewImage(file) {
      if (file) {
        const reader = new FileReader();
        this.newImages.push({
          file: file,
          imageUrl: null
        });
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.newImages[this.newImages.length - 1].imageUrl = reader.result;
        };
      }
    },
    deleteNewImage(index) {
      this.newImages.splice(index, 1);
    },
    deleteImage(image) {
      this.$store.dispatch(DELETE_IMAGE_PRODUCT, {
        productId: this.product.id,
        imageId: image.id
      });
    },
    onClose() {
      this.$emit("update:dialog", false);
      this.newImages = [];
    },
    onSave() {
      this.$store.dispatch(ADD_IMAGE_PRODUCT, {
        productId: this.product.id,
        images: this.newImages
      });
      this.newImages = [];
      this.$emit("update:dialog", false);
    },
    setValue(product) {
      this.product = product;
      this.$store.dispatch(GET_IMAGES_PRODUCT, this.product.id);
    }
  },
  watch: {
    dialog(value) {
      this.dialogModel = value;
    },
    dialogModel(value) {
      this.$emit("update:dialog", value);
    }
  }
};
</script>

<style scoped>
.image-preview {
  display: inline-block;
  position: relative;
  max-width: 20em;
}
.image-preview img {
  display: block;
  max-width: 100%;
}

.delete-button {
  position: absolute;
  top: -2em;
  right: -2em;
}
</style>
